import { LaunchDarklyFeatureFlags } from '@core/feature-flags';
import { useLicense } from '@core/license';
import { useUser } from '@core/user';
/**
 * Custom hook to determine if a user is authorized to access a resource based on the provided `canRender` parameter.
 *
 * @param canRender - A boolean or a function that takes `GuardParameters` and returns a boolean.
 * @returns A boolean indicating whether the user is authorized.
 */ export var useIsAuthorized = function useIsAuthorized(canRender) {
    var _useUser = useUser(), user = _useUser.access;
    var license = useLicense();
    return typeof canRender === 'boolean' ? canRender : canRender({
        user: user,
        license: license,
        hasFeatureFlag: function hasFeatureFlag(flag, project) {
            return LaunchDarklyFeatureFlags.isActive(flag, project);
        }
    });
};

//# sourceMappingURL=useIsAuthorized.js.map